import { ParticipationTypeEnum, type ParticipationType, type ReasonEnd, type ReasonStart } from 'app/types';

export type { ReasonStart, ReasonEnd };

export const ParticipationTranslationKeys = {
  wiaTitle: 'employees.income.participation.wiaTitle',
  wgaTitle: 'employees.income.participation.wgaTitle',
  noParticipations: 'employees.income.participation.noParticipations',
  addButton: 'employees.income.participation.addButton',
  startDate: 'employees.income.participation.startDate',
  endDate: 'employees.income.participation.endDate',
  type: 'employees.income.participation.type',
  reasonStart: 'employees.income.participation.reasonStart',
  reasonEnd: 'employees.income.participation.reasonEnd',
  confirmDeleteTitle: 'employees.income.participation.confirmDeleteTitle',
  confirmDeleteMessage: 'employees.income.participation.confirmDeleteMessage',
  dialogTitleCreate: 'employees.income.participation.dialogTitleCreate',
  dialogTitleEdit: 'employees.income.participation.dialogTitleEdit',
  reasonStart_new_employee: 'employees.income.participation.reasonStart.new_employee',
  reasonStart_recovered_after_illness: 'employees.income.participation.reasonStart.recovered_after_illness',
  reasonStart_reconsideration_optional_insurance:
    'employees.income.participation.reasonStart.reconsideration_optional_insurance',
  reasonStart_salary_above_max_premium_wage: 'employees.income.participation.reasonStart.salary_above_max_premium_wage',
  reasonStart_start_member_of_insured_group: 'employees.income.participation.reasonStart.start_member_of_insured_group',
  type_wia_excedent: 'employees.income.participation.type.wia_excedent',
  type_wga_hiaat_basis: 'employees.income.participation.type.wga_hiaat_basis',
  type_wga_hiaat_plus: 'employees.income.participation.type.wga_hiaat_plus',
  type_wga_hiaat_uitgebreid: 'employees.income.participation.type.wga_hiaat_uitgebreid',
  reasonEnd_deceased: 'employees.income.participation.reasonEnd.deceased',
  reasonEnd_end_optional_insurance: 'employees.income.participation.reasonEnd.end_optional_insurance',
  reasonEnd_salary_below_max_premium_wage: 'employees.income.participation.reasonEnd.salary_below_max_premium_wage',
  reasonEnd_end_member_of_insured_group: 'employees.income.participation.reasonEnd.end_member_of_insured_group',
  duplicateActiveParticipationException: 'DuplicateActiveParticipationException',
} as const;

export const REASON_START_TRANSLATION_KEY: Record<ReasonStart, string> = {
  new_employee: ParticipationTranslationKeys.reasonStart_new_employee,
  recovered_after_illness: ParticipationTranslationKeys.reasonStart_recovered_after_illness,
  reconsideration_optional_insurance: ParticipationTranslationKeys.reasonStart_reconsideration_optional_insurance,
  salary_above_max_premium_wage: ParticipationTranslationKeys.reasonStart_salary_above_max_premium_wage,
  start_member_of_insured_group: ParticipationTranslationKeys.reasonStart_start_member_of_insured_group,
};

export const REASON_END_TRANSLATION_KEY: Record<ReasonEnd, string> = {
  deceased: ParticipationTranslationKeys.reasonEnd_deceased,
  end_optional_insurance: ParticipationTranslationKeys.reasonEnd_end_optional_insurance,
  salary_below_max_premium_wage: ParticipationTranslationKeys.reasonEnd_salary_below_max_premium_wage,
  end_member_of_insured_group: ParticipationTranslationKeys.reasonEnd_end_member_of_insured_group,
};

export const PARTICIPATION_TYPE_TRANSLATION_KEY: Record<ParticipationType, string> = {
  wia_excedent: ParticipationTranslationKeys.type_wia_excedent,
  wga_hiaat_basis: ParticipationTranslationKeys.type_wga_hiaat_basis,
  wga_hiaat_plus: ParticipationTranslationKeys.type_wga_hiaat_plus,
  wga_hiaat_uitgebreid: ParticipationTranslationKeys.type_wga_hiaat_uitgebreid,
};

export const WGA_TYPES: ParticipationType[] = [
  ParticipationTypeEnum.WGAHiaatBasis,
  ParticipationTypeEnum.WGAHiaatPlus,
  ParticipationTypeEnum.WGAHiaatUitgebreid,
];
export const WIA_TYPES: ParticipationType[] = [ParticipationTypeEnum.WIAExcedent];

export const REASON_START_VALUES: ReasonStart[] = [
  'new_employee',
  'recovered_after_illness',
  'reconsideration_optional_insurance',
  'salary_above_max_premium_wage',
  'start_member_of_insured_group',
];

export const REASON_END_VALUES: ReasonEnd[] = [
  'deceased',
  'end_optional_insurance',
  'salary_below_max_premium_wage',
  'end_member_of_insured_group',
];

export type ParticipationFormValues = {
  startDate: string | null;
  endDate: string | null;
  type: ParticipationType | '';
  reasonStart: ReasonStart | '';
  reasonEnd: ReasonEnd | '';
};
